import CanvasLightTheme from 'foundations-theming-base/stable/canvas/light/theme';
export default CanvasLightTheme;